import Vue from 'vue'
import Vuex from 'vuex'
import {getActivityBluetoochList} from "~/api/apps";
import modules from './modules';
import {creatUdid} from "~/utils/creatUdid";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: () => ({
    loading: false, //页面loading
    authenticationAlert: false, //身份认证弹窗
    reapplyAlert: false, //再次申请弹窗
    loginAlert: false, // 登录弹窗
    userInfo: {},//用户信息
    companyInfo: {},//企业信息
    smproApp: 0, // 网维助手拆分app的名称
    showInquiryAlert:false,//注册初次登录
    showAboutUpVersion:false,//展示用户协议隐私政策更新弹窗
    bluetoochSwitch:0,//蓝牙模块活动是否存在 0不存在 1存在
    bluetoochStartTime:'',//蓝牙模块活动开始时间
    bluetoochEndTime:'',//蓝牙模块活动结束时间
  }),
  mutations: {
    SET_BLUETOOCH_START_TIME(state, bluetoochSwitch) {
      state.bluetoochStartTime = bluetoochSwitch;
    },
    SET_BLUETOOCH_END_TIME(state, bluetoochSwitch) {
      state.bluetoochEndTime = bluetoochSwitch;
    },
    SET_BLUETOOCH_SWITCH(state, bluetoochSwitch) {
      state.bluetoochSwitch = bluetoochSwitch;
    },
    SET_SHOW_ABOUT_UP_VERSION(state, value) {
      state.showAboutUpVersion = value;
    },
    SET_SHOW_INQUIRY_ALERT(state, value) {
      state.showInquiryAlert = value;
    },
    SET_SMPRO_APP(state, value) {
      state.smproApp = value;
    },
    LOADING_STATE(state, value) { //页面loading
      state.loading = value;
    },
    AUTHENTICATION_ALERT(state, value) { //身份认证弹窗
      state.authenticationAlert = value;
    },
    REAPPLY_ALERT(state, value) { //再次申请弹窗
      state.reapplyAlert = value;
    },
    LOGIN_ALERT(state, value) { //登录弹窗
      state.loginAlert = value;
    },
    USER_INFO(state, value) { //用户信息
      state.userInfo = value;
    },
    COMPANY_INFO(state, value) { //企业信息
      state.companyInfo = value;
    }
  },
  getters: {
    getterSmproApp: (state) => {
      return state.smproApp;
    }
  },
  actions: {
    setBluetoochSwitch({commit}, status) {
      getActivityBluetoochList().then(res=>{
        commit('SET_BLUETOOCH_SWITCH', res.data.activitySwitch)
        if(res.data.activitySwitch===1){
          commit('SET_BLUETOOCH_START_TIME', res.data.startTime.slice(0,10).replace(/-/g, '.'))
          commit('SET_BLUETOOCH_END_TIME', res.data.endTime.slice(0,10).replace(/-/g, '.'))
        }
      })
    },
    setShowAboutUpVersion({commit}, status) {
      commit('SET_SHOW_ABOUT_UP_VERSION', status)
    },
    /**
     * 修改网维助手拆分app的名称
     * */
    setSmproApp({commit}, val) {
      commit('SET_SMPRO_APP', val);
    },
    setShowInquiryAlert({commit}, val) {
      commit('SET_SHOW_INQUIRY_ALERT', val);
    },
  },
  modules
})
export default () => {
  return store;
}

